'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var CHECK = 'M9.00016 16.17L4.83016 12L3.41016 13.41L9.00016 19L21.0002 6.99997L19.5902 5.58997L9.00016 16.17Z';
var IconCheck = lib.variant('IconCheck', icon.Icon, {
    path: CHECK,
});

exports.CHECK = CHECK;
exports.IconCheck = IconCheck;
//# sourceMappingURL=index-e2300009.js.map
